export const classes = {
  wrapper: 'relative place-center h-screen w-screen overflow-hidden',
};
